import { Grid2 as Grid } from "@mui/material";
import { ColDef, GridApi, themeMaterial } from "ag-grid-community";
import { AgGridReact } from "ag-grid-react";
import { useState } from "react";
import { useGridDefinitions } from "../../../../controls/ag-grid/components/GridDefinitions";
import { useGridStyles } from "../../styles/gridStyles";

type Props = {
	rows: [];
	columnDefs: [];
	defaultColDef: ColDef<any>;
};

export const TableMonthReport = ({
	rows,
	columnDefs,
	defaultColDef,
}: Props) => {
	const [gridApi, setGridApi] = useState<GridApi | null>(null);
	const { columnDefaults, columnTypes } = useGridDefinitions({
		OnEdit: (data: any) => {},
	});
	columnDefaults.floatingFilter = false;

	const classes = useGridStyles();
	return (
		<Grid container style={{ width: "100%", display: "flex" }}>
			<Grid
				size={{ xs: 12 }}
				style={{
					height: "37vh",
					minHeight: "37vh",
					border: "1px solid #e0e0e0",
					width: "100%",
					borderRadius: 10,
				}}
			>
				<AgGridReact
					rowSelection="single"
					defaultColDef={defaultColDef}
					rowData={rows || []}
					columnDefs={columnDefs}
					columnTypes={columnTypes}
					onGridReady={(params) => setGridApi(params.api)}
					rowHeight={35}
				/>
			</Grid>
		</Grid>
	);
};
